const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
const cartWrapper = document.querySelector('.nhead__ecomcartwrapper');
const cartQuantity = document.querySelector('.ecomcartwrappe__quantity');

function getCookie(name) {
	let result = document.cookie.match(new RegExp(name + '=([^=;]+)?'));
	return result && result[1];
}

let cartData = getCookie("cart_items");

if (cartData) {
	cartData = JSON.parse(decodeURIComponent(cartData));
} else {
	cartData = {};
}

document.querySelectorAll('.catalog__inner').forEach(function (container) {
	container.querySelectorAll(':scope > .catalog__item').forEach(function (item) {
		const productId = item.getAttribute('data-catalog-item-id');
		const quantitySpan = item.querySelector('.catalogitem__quantity');
		const addButton = item.querySelector('.catalogitem__controller--add');
		const restButton = item.querySelector('.catalogitem__controller--rest');
		const buttonUpdateText = item.querySelector('.catalogitem__updatetext');
		const updateButton = item.querySelector('.catalogitem__update');
		const loader = item.querySelector('.update__loader');

		let actualQuantity = parseInt(quantitySpan.textContent.trim(), 10);

		let quantity = cartData && cartData[productId] ? cartData[productId] : 0;
		if (quantitySpan) {
			quantitySpan.textContent = quantity;
		}

		if (quantity > 0 && buttonUpdateText) {
			buttonUpdateText.innerText = buttonUpdateText.dataset.basketUpdate;
		} else {
			buttonUpdateText.innerText = buttonUpdateText.dataset.basketAdd;
		}

		function updateQuantity(amount) {
			quantity = Math.max(0, quantity + amount);
			quantitySpan.textContent = quantity;
			cartData[productId] = quantity;
		}

		if (addButton) {
			addButton.addEventListener('click', function (event) {
				event.preventDefault();
				updateQuantity(1);
			});
		}

		if (restButton) {
			restButton.addEventListener('click', function (event) {
				event.preventDefault();
				updateQuantity(-1);
			});
		}


		updateButton.addEventListener('click', (event) => {
			event.preventDefault();
			let newQuantity = parseInt(quantitySpan.textContent.trim(), 10);

			if (actualQuantity !== newQuantity || (actualQuantity === 0 && newQuantity === 0)) {
				loader.classList.toggle('d__none');
				buttonUpdateText.innerText = '';

				if (cartData && !cartData[productId] && newQuantity === 0 && !actualQuantity) {
					newQuantity = 1;
					quantity = 1;
				}

				fetch(`/shoppingcart/setquantity/0/${productId}?quantity=${newQuantity}`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'X-SecurityID': csrfToken,
					},
				}).then(response => response.json())
					.then(data => {
						cartWrapper.classList.remove('nhead__ecomcartwrapper--hide');
						updateButton.disabled = false;
						addButton.disabled = false;
						restButton.disabled = false;
						actualQuantity = data.quantity
						loader.classList.toggle('d__none');
						quantitySpan.innerHTML = data.quantity;
						if (data.quantity === 0) {
							buttonUpdateText.innerText = buttonUpdateText.dataset.basketAdd
						} else {
							buttonUpdateText.innerText = buttonUpdateText.dataset.basketUpdate
						}
						cartQuantity.classList.add('ecomcartwrappe__quantity--updated');
						setTimeout(() => {
							cartQuantity.classList.remove('ecomcartwrappe__quantity--updated');
						}, 1000);
						cartQuantity.innerText = data.total_items
						cartData[productId] = data.quantity;
					});
			}
		});


	});
});